/**
 * The app surface the Asset Details page was opened from. Threaded via the
 * `origin` search param and used to decide whether a class change warns the
 * user with the score-impact dialog (PDP) or applies immediately (Library /
 * Collections).
 */
const ASSET_DETAILS_ORIGINS = ['pdp', 'library', 'collection'] as const;

type AssetDetailsOrigin = (typeof ASSET_DETAILS_ORIGINS)[number];

/**
 * Narrows an unknown search-param value to a known origin, or undefined.
 */
function parseAssetDetailsOrigin(value: unknown): AssetDetailsOrigin | undefined {
  return typeof value === 'string' && (ASSET_DETAILS_ORIGINS as readonly string[]).includes(value)
    ? (value as AssetDetailsOrigin)
    : undefined;
}

/**
 * Whether changing an asset's class from this surface should first warn the
 * user via the score-impact dialog. Only the PDP surface warns; Library and
 * Collections apply immediately. Unknown/absent origin (deep-link, refresh)
 * defaults to showing the dialog so we never silently skip the warning.
 */
function requiresScoreImpactDialog(origin: AssetDetailsOrigin | undefined): boolean {
  return origin !== 'library' && origin !== 'collection';
}

export { ASSET_DETAILS_ORIGINS, parseAssetDetailsOrigin, requiresScoreImpactDialog };
export type { AssetDetailsOrigin };
